import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';

import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';
import { MaterialModule } from '@app/material.module';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RecordToolbarModule } from '@app/shared/record-toolbar/record-toolbar.module';
import { TimeTrackerTableModule } from '@app/shared/time-tracker-table/time-tracker-table.module';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { UserAvatarModule } from '@app/shared/user-avatar/user-avatar.module';
import { UserMenuModule } from '@app/shared/user-menu/user-menu.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { TimeTrackerCalendarModule } from '@app/shared/time-tracker-calendar/time-tracker-calendar.module';
import { TimeRangePickerModule } from '@app/shared/time-range-picker/time-range-picker.module';
import { DateFnsModule } from 'ngx-date-fns';
import { CustomDirectivesModule } from '@app/_directives/custom-directives.module';
import { HomeMobileControlsComponent } from './home-mobile-controls/home-mobile-controls.component';
import { HomeTimerComponent } from './home-timer/home-timer.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ScrollingModule as ExperimentalScrollingModule } from '@angular/cdk-experimental/scrolling';
import { ShellMenuToggleModule } from '@app/components/shell-menu-toggle/shell-menu-toggle.module';
import { FrillButtonModule } from '@app/components/frill-button/frill-button.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    CoreModule,
    ReactiveFormsModule,
    SharedModule,
    FlexLayoutModule,
    MaterialModule,
    HomeRoutingModule,
    UserMenuModule,
    RecordToolbarModule,
    AngularSvgIconModule,
    NgScrollbarModule,
    InfiniteScrollModule,
    TimeTrackerTableModule,
    TimeTrackerCalendarModule,
    TimeRangePickerModule,
    UserAvatarModule,
    DateFnsModule,
    CustomDirectivesModule,
    NgxSkeletonLoaderModule,
    ScrollingModule,
    ShellMenuToggleModule,
    FrillButtonModule,
    ExperimentalScrollingModule,
  ],
  declarations: [HomeComponent, HomeMobileControlsComponent, HomeTimerComponent],
  providers: [],
})
export class HomeModule {}
